import Backbone from 'backbone'
import _ from 'lodash'
import Dataset from '../datasets/model/dataset'

const DataSourceSavingView = Backbone.View.extend(/** @lends {DataSourceSavingView} */{

	/**
	 * Super class for views which are the last step that is involved in
	 * modifying a data source for an import or dataset.
	 *
	 * @param {Object} options
	 *
	 * @param {Importable} options.model
	 *
	 * @param {Wizard} options.wizard the wizard this rest request is a part
	 * of
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	success: function(response) {
		if (this.options.wizard.isLastStep()) {
			// #35831 when editing an existing datasource, save
			// *after* validation
			this.save()
		} else {
			this.model.set(response)
			let wizard = this.options.wizard
			if (wizard.steps == wizard.step) {
				this.trigger('done', this.model)
			} else {
				wizard.next()
			}
		}
	},

	save: function() {
		let url = _.result(this.model, 'url')
		if (this.model instanceof Dataset) {
			url += '/data-source-info'
		}
		return this.model.save({}, {
			url,
			success: () => {
				this.trigger('done', this.model)
				this.options.wizard.finish(this.model)
			},
			error: (model, response) => this.formView.error(response)
		})
	}

})

export default DataSourceSavingView

DataSourceSavingView.__filename__ = 'imports/data-source-saving-view.js'
